import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';

import {selectCms} from 'coreStore/data/configurations';
import {RootState} from 'coreStore/types';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * Hook to get the content manager
 * It listens to the cms state to get the content manager
 */
const useContentMgr = () => {
	const {managerRepository} = useGeneralProvider();

	const cms = useSelector((state: RootState) => selectCms(state));

	return useVersioned(managerRepository.getContentMgr(), cms);
};

export default useContentMgr;
